module.exports = __webpack_public_path__ + "img/invite_man.bac2d886.png";